(() => {
  'use strict';

  const script = document.currentScript;
  const prefix = '#mrbrands-brief=';
  const maximumBytes = 12000;
  const limits = { name: 100, business: 120, email: 254, website: 2048, goal: 450, budget: 100, brief: 1800 };
  const packages = {
    'Starter – £95/month': { budget: 'Starter – £95/month', help: 'Starter Website & SEO – launch or improve a focused website' },
    'Foundation – £285/month': { budget: 'Foundation – £285/month', help: 'Foundation Website – build or replace a website' },
    'Growth – £547.50/month': { budget: 'Growth – £547.50/month', help: 'Growth Website – larger website and SEO programme' },
    'Scale – £997.50/month': { budget: 'Scale – £997.50/month', help: 'Scale Website – high-capacity growth system' }
  };
  const text = (key, fallback) => script?.dataset[key] || fallback;

  function clearFragment() {
    try { history.replaceState(history.state, '', location.pathname + location.search); }
    catch { }
  }

  function notice(form, valid) {
    if (document.getElementById('mrbrands-design-review')) return;
    const box = document.createElement('section');
    box.id = 'mrbrands-design-review';
    box.setAttribute('role', 'status');
    box.style.cssText = 'max-width:920px;margin:0 auto 24px;padding:20px 24px;border:1px solid #cbd3b9;border-radius:8px;background:#f5f8e9;color:#171914;';
    const heading = document.createElement('h2');
    heading.style.cssText = 'font-family:inherit;font-size:20px;line-height:1.3;font-weight:600;color:inherit;margin:0 0 8px;';
    heading.textContent = text('reviewTitle', 'Your project details are ready to review');
    const body = document.createElement('p');
    body.style.cssText = 'font-size:15px;line-height:1.6;margin:0;';
    body.textContent = valid
      ? text('reviewBody', 'Your project details are below. Review your details and consent before requesting your Teams call. Nothing has been sent yet.')
      : text('invalidBody', 'This design link could not be read. You can still describe your project in the form below. Nothing has been sent.');
    box.append(heading, body);
    form.before(box);
  }

  function readBrief() {
    const fragment = location.hash;
    if (!fragment.startsWith(prefix)) return null;
    if (new TextEncoder().encode(fragment).length > maximumBytes) throw new Error('Brief too large');
    const raw = JSON.parse(decodeURIComponent(fragment.slice(prefix.length)));
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) throw new Error('Invalid brief');
    const clean = Object.create(null);
    for (const [key, maximum] of Object.entries(limits)) {
      if (!Object.prototype.hasOwnProperty.call(raw, key) || typeof raw[key] !== 'string') continue;
      clean[key] = raw[key].replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/g, '').slice(0, maximum).trim();
    }
    if (!Object.values(clean).some(Boolean)) throw new Error('Empty brief');
    return clean;
  }

  function setValue(form, name, value) {
    if (!value) return;
    const field = form.elements.namedItem(name);
    if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement || field instanceof HTMLSelectElement)) return;
    if (field instanceof HTMLSelectElement) {
      const option = Array.from(field.options).find(item => item.value === value || item.text === value);
      if (!option) return;
      field.value = option.value;
    } else {
      const maximum = field.maxLength > -1 ? field.maxLength : value.length;
      field.value = value.slice(0, maximum);
    }
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function receive() {
    if (!/\/pages\/contact\/?$/.test(location.pathname) || !location.hash.startsWith(prefix)) return;
    const form = document.getElementById('contact_form');
    if (!(form instanceof HTMLFormElement) || form.method.toLowerCase() !== 'post') return;
    const action = new URL(form.action, location.href);
    if (action.origin !== location.origin || !/\/contact\/?$/.test(action.pathname)) return;
    form.querySelectorAll('input[type="checkbox"]').forEach(input => { input.checked = false; });
    let brief;
    try { brief = readBrief(); }
    catch { clearFragment(); notice(form, false); return; }
    if (!brief) return;
    clearFragment();
    setValue(form, 'contact[name]', brief.name);
    setValue(form, 'contact[Business name]', brief.business);
    setValue(form, 'contact[email]', brief.email);
    if (brief.website) {
      try {
        const candidate = /^[a-z][a-z\d+.-]*:/i.test(brief.website) ? brief.website : 'https://' + brief.website;
        const website = new URL(candidate);
        if (website.protocol === 'https:' || website.protocol === 'http:') setValue(form, 'contact[Website]', website.href);
      } catch { }
    }
    setValue(form, 'contact[Main priority]', brief.goal);
    const selectedPackage = Object.prototype.hasOwnProperty.call(packages, brief.budget) ? packages[brief.budget] : null;
    setValue(form, 'contact[Monthly investment]', selectedPackage?.budget || brief.budget);
    setValue(form, 'contact[Help requested]', selectedPackage?.help || 'Not sure – advise me');
    const lines = [brief.brief || 'MrBrands Design Studio enquiry'];
    if (brief.goal && !lines[0].includes(brief.goal)) lines.push('Main goal: ' + brief.goal);
    if (brief.budget && !lines[0].includes(brief.budget)) lines.push('Monthly investment: ' + brief.budget);
    setValue(form, 'contact[body]', lines.join('\n\n').slice(0, 1800));
    notice(form, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', receive, { once: true });
  else receive();
})();

